import styled from '@emotion/styled';

export const AdminPanelWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
    width: 100%;
`;
